import { render, staticRenderFns } from "./Sidenav.vue?vue&type=template&id=04dee6a0&scoped=true&"
import script from "./Sidenav.vue?vue&type=script&lang=js&"
export * from "./Sidenav.vue?vue&type=script&lang=js&"
import style0 from "./Sidenav.vue?vue&type=style&index=0&id=04dee6a0&lang=scss&scoped=true&"
import style1 from "./Sidenav.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dee6a0",
  null
  
)

export default component.exports